import { useEffect, useState } from 'preact/hooks'
import LoadingIndicator from '../LoadingIndicator'

export type QuizLoadingProps = {
  timeout?: number
  onLoadingComplete?: () => void
  messages?: string[]
}

const placeholderMessages = ['Analyzing Your Answers...', 'Almost There...']

export default function QuizLoading({
  onLoadingComplete,
  timeout = 2000,
  messages = placeholderMessages
}: QuizLoadingProps) {
  const [message, setMessage] = useState(messages[0] ?? placeholderMessages[0])

  useEffect(() => {
    setTimeout(() => {
      setMessage(messages[1] ?? placeholderMessages[1])
    }, timeout * 0.5)
    setTimeout(() => onLoadingComplete?.(), timeout)
  }, [onLoadingComplete, timeout, messages])

  return (
    <div className='flex flex-col items-center gap-y-4 md:gap-y-6'>
      <LoadingIndicator color='fresh-scent' size={48} />
      <h6 className='md:text-2xl'>{message}</h6>
    </div>
  )
}
